import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import supabase from '../../supabase/supabase';
import SafeIcon from '../../common/SafeIcon';
import ParticipantView from './views/ParticipantView';
import ManagerView from './views/ManagerView';
import AdminView from './views/AdminView';
import ComplianceTimingLogs from './views/ComplianceTimingLogs';

const Dashboard = () => {
  const { user } = useAuth();
  const [checkedIn, setCheckedIn] = useState(false);
  const [attendance, setAttendance] = useState([]);

  useEffect(() => {
    if (user?.role === 'participant') {
      fetchAttendance();
    }
  }, [user]);

  const fetchAttendance = async () => {
    const { data } = await supabase
      .from('attendance_1741860000000')
      .select('*')
      .eq('user_id', user.id)
      .order('check_in_time', { ascending: false })
      .limit(5);

    setAttendance(data || []);
    const today = new Date().toISOString().split('T')[0];
    const checkedToday = data?.some(a => a.check_in_time.startsWith(today));
    setCheckedIn(!!checkedToday);
  };

  const handleCheckIn = async () => {
    try {
      const { error } = await supabase
        .from('attendance_1741860000000')
        .insert([{ 
          user_id: user.id, 
          session_name: "Leadership & Resillience Day 1",
          ip_address: "Registered Device" 
        }]);
      
      if (error) throw error;
      setCheckedIn(true);
      fetchAttendance();
      alert("Check-in successful!");
    } catch (err) {
      alert("Check-in failed: " + err.message);
    }
  };

  return (
    <div className="max-w-6xl mx-auto">
      <header className="mb-8 flex justify-between items-start">
        <div>
          <h1 className="text-3xl font-serif font-bold text-navy-900">
            Welcome back, {user?.profile?.first_name || 'User'}
          </h1>
          <div className="flex items-center gap-2 mt-2">
             <span className="text-xs font-bold uppercase tracking-widest text-gold-600 bg-gold-50 px-2 py-1 rounded border border-gold-100">
               {user?.role?.replace('_', ' ')}
             </span>
             <span className="text-slate-400 text-sm">• {user?.org}</span>
          </div>
        </div>

        {user?.role === 'participant' && (
          <div className="flex items-center gap-4">
            {!checkedIn ? (
              <button 
                onClick={handleCheckIn}
                className="bg-navy-900 text-white px-6 py-3 rounded-xl font-bold flex items-center gap-2 hover:bg-navy-800 shadow-xl"
              >
                <SafeIcon name="CheckCircle" className="w-5 h-5 text-gold-500" />
                Session Check-In
              </button>
            ) : (
              <div className="bg-green-50 text-green-700 px-6 py-3 rounded-xl font-bold flex items-center gap-2 border border-green-200">
                <SafeIcon name="Check" className="w-5 h-5" />
                Attendance Logged
              </div>
            )}
          </div>
        )}
      </header>

      {user?.role === 'participant' && <ParticipantView attendance={attendance} />}
      {user?.role === 'manager' && <ManagerView />}
      {user?.role === 'admin' && <AdminView />}
      {user?.role === 'compliance' && <ComplianceTimingLogs />}
    </div>
  );
};

export default Dashboard;